import {
  Box,
  Checkbox,
  Divider,
  FormControl,
  MenuItem,
  Select,
  SelectChangeEvent,
  Typography
} from '@mui/material'
import CheckIcon from '@mui/icons-material/Check'
import { useTranslation } from 'react-i18next'

interface AssembleOptionsProps {
  isHingeable: boolean
  isAssembled: boolean
  hingeDirection: string
  onUpdate: (update: { isAssembled?: boolean; hingeDirection?: string }) => void
}

const AssembleOptions: React.FC<AssembleOptionsProps> = ({
  isHingeable,
  isAssembled,
  hingeDirection,
  onUpdate
}) => {
  const { t } = useTranslation()

  const handleAssembledToggle = () => {
    const newAssembled = !isAssembled
    onUpdate({
      isAssembled: newAssembled,
      ...(isHingeable && newAssembled ? { hingeDirection: 'LEFT' } : {})
    })
  }

  const handleHingeChange = (e: SelectChangeEvent<string>) => {
    const direction = e.target.value
    onUpdate({ hingeDirection: direction })
  }

  const currentHinge = hingeDirection || 'LEFT'

  return (
    <>
      <Divider sx={{ width: '100%', mb: 2 }} />
      <Box display='flex' gap='16px'>
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            gap: '10px',
            cursor: 'pointer'
          }}
          onClick={handleAssembledToggle}
        >
          <Checkbox
            checked={isAssembled}
            disableRipple
            icon={
              <Box
                sx={{
                  width: 16,
                  height: 16,
                  border: '1px solid #E0E0E0',
                  borderRadius: '2px',
                  boxSizing: 'border-box'
                }}
              />
            }
            checkedIcon={
              <Box
                sx={{
                  width: 16,
                  height: 16,
                  borderRadius: '2px',
                  backgroundColor: 'primary.main',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  boxSizing: 'border-box'
                }}
              >
                <CheckIcon sx={{ fontSize: 14, color: '#FFFFFF' }} />
              </Box>
            }
            sx={{ padding: 0 }}
          />
          <Typography
            sx={{
              fontFamily: 'Inter',
              fontSize: '14px',
              fontWeight: 500
            }}
          >
            {t('productDetail.assembled')}
          </Typography>
        </Box>

        {isHingeable && (
          <FormControl variant='outlined' sx={{ borderRadius: '4px' }}>
            <Select
              value={currentHinge}
              onChange={handleHingeChange}
              disabled={!isAssembled}
              renderValue={val =>
                val === 'LEFT'
                  ? t('productDetail.hingeLeft')
                  : t('productDetail.hingeRight')
              }
              sx={{
                width: '150px',
                height: '32px',
                fontFamily: 'Inter',
                fontSize: '14px',
                fontWeight: 500,
                textAlign: 'left'
              }}
            >
              <MenuItem value='LEFT'>{t('productDetail.hingeLeft')}</MenuItem>
              <MenuItem value='RIGHT'>{t('productDetail.hingeRight')}</MenuItem>
            </Select>
          </FormControl>
        )}
      </Box>
    </>
  )
}

export default AssembleOptions
